const isString = (value = null) => {
  let regex = /^[a-zA-Z\s]{0,45}$/g;
  return regex.test(value);
};

const isName = (value = null) => {
  let regex = /^[a-zA-Z\s]{0,50}$/g;
  return regex.test(value);
};

const isNumber = (value = null) => {
  let regex = /^[0-9]*$/g;
  return regex.test(value);
};

const isText = (value = null) => {
  let regex = /^[a-zA-Z0-9-_\s]{0,45}$/g;
  return regex.test(value);
};

const isAlphaNum = (value = null) => {
  let regex = /^[a-zA-Z0-9\s]{0,50}$/g;
  return regex.test(value);
};

const isAlphanNumWithChar = (value = null) => {
  let regex = /^[a-zA-Z0-9-_\s]{0,50}$/g;
  return regex.test(value);
};

const isUserID = (value = null) => {
  let regex = /^[a-zA-Z0-9]{0,48}$/g;
  return regex.test(value);
};

const isMobileNum = (value = null) => {
  let regex = /^[0-9]{0,10}$/g;
  return regex.test(value);
};

const validateEmail = (value = null) => {
  const regex = /^[a-zA-Z0-9@.]{0,80}$/g;
  return regex.test(value);
};

const isEmail = (value = null) => {
  const regex = /^[[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g;
  return regex.test(value);
};

const isAmount = (value = null) => {
 if (value.includes(".")) {
  const regex = /^[0-9]{0,9}\.+[0-9]{0,2}$/g;
  return regex.test(value);
 }else{
   const regex = /^[0-9]{0,9}$/g;
   return regex.test(value);
 }
};

const regexService = {
  isString: (value) => isString(value),
  isAlphaNum: (value) => isAlphaNum(value),
  isNumber: (value) => isNumber(value),
  isMobileNum: (value) => isMobileNum(value),
  isEmail: (value) => isEmail(value),
  validateEmail: (value) => validateEmail(value),
  isText: isText,
  isUserID: isUserID,
  isAlphanNumWithChar: isAlphanNumWithChar,
  isName: isName,
  isAmount: isAmount,
};

export default regexService;
